/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-31 10:59:19
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-15 15:14:00
 * @FilePath: /unifyxp-v2-store-portal/src/config/routerConfig/salesChannelProducts/index.tsx
 */
import {
  SalesChannelProductAlias,
  SalesChannelProductAliasEdit,
  SalesChannelProductContent,
  SalesChannelProductCustomization,
  SalesChannelProductsLinkProduct,
} from '@/src/pages/SalesChannelProductsConfig';
import { IRouteSubRoutes } from 'src/types/router';
import { productDetailPage } from 'src/tools/permissions/salesChannelPermissions';
import { EPermissionSource } from 'src/types/common/resources';
import { salesChannelRoutes } from 'src/tools/urlMap';

const listRoutes: IRouteSubRoutes[] = [
  {
    exact: true,
    path: salesChannelRoutes.salesChannelProductsLinkProductDetail, // '/salesChannel/products/link/:saleChannelUuid/:salesChannelProductUuid',
    component: SalesChannelProductsLinkProduct,
    isPrivate: true,
    //permissionGroup: [EnumPermissions.CANTEST],
    permissionGroupGenerate: productDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.salesChannelProductContent, //'/salesChannel/products/content/:saleChannelUuid/:salesChannelProductUuid',
    component: SalesChannelProductContent,
    isPrivate: true,
    permissionGroupGenerate: productDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.salesChannelProductCustomization, //'/salesChannel/products/customisation/:saleChannelUuid/:salesChannelProductUuid',
    component: SalesChannelProductCustomization,
    isPrivate: true,
    permissionGroupGenerate: productDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.salesChannelProductAlias, //'/salesChannel/products/alias/:saleChannelUuid/:salesChannelProductUuid',
    component: SalesChannelProductAlias,
    isPrivate: true,
    permissionGroupGenerate: productDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.salesChannelProductAliasEdit, //'/salesChannel/products/alias/:saleChannelUuid/:salesChannelProductUuid/:aliasUuid',
    component: SalesChannelProductAliasEdit,
    isPrivate: true,
    permissionGroupGenerate: productDetailPage,
    source: EPermissionSource.salesChannel,
  },
];
export default listRoutes;
